import random from './random';
import { storage, OAUTH_STATE } from '../app/Storage';

export class OAuthState {
    static getStateString() {
        let state = random();
        storage.set(OAUTH_STATE, state);
        return state;
    }

    static getStateAsTuple() {
        return ["state", OAuthState.getStateString()];
    }

    static getStateAsQueryString() {
        return "state=" + OAuthState.getStateString();
    }

    static isValidState(stateReceived) {
        let storedState = storage.getAndRemove(OAUTH_STATE);
        return storedState === stateReceived;
    }
}


// WEBPACK FOOTER //
// ./src/authentication/OAuthState.js